// State
export const state = () => ({
  loading: false,
  withdrawalExistingData: {},
  withdrawEventsBody: {}
})

// Actions
export const actions = {
  // Get check withdrawal
  async checkExistWithdrawal({ commit }) {
    this.commit('settings/setCancelToken', {
      existWithdraw: this.$axios.CancelToken.source()
    })
    try {
      const response = await this.$axios.get('/withdrawals/check/is-exists', {
        cancelToken: this.state.settings.cancelToken.existWithdraw.token
      })
      commit('setWithdrawalExistingData', response.data)
      return response.data
    } catch (error) {
      return {}
    }
  },
  // Create withdraw
  async createWithdraw({ commit, dispatch, state }, form) {
    commit('setLoading', true)
    const data = { ...form }
    if (state?.withdrawEventsBody?.px_id) {
      data.event_data = { ...state.withdrawEventsBody }
    }
    try {
      const response = await this.$axios.post('/withdrawals', data)
      await dispatch('player/profile', true, {
        root: true
      })
      return response.data
    } catch (error) {
    } finally {
      commit('setLoading', false)
    }
  },
  // Cancel withdraw
  async cancelWithdraw({ commit }, id) {
    commit('setLoading', true)
    try {
      const response = await this.$axios.put('/withdrawals/cancel/' + id, {})
      return response.data
    } catch (error) {
    } finally {
      commit('setLoading', false)
    }
  },
  async createCryptoWithdrawal({ commit, dispatch, state }, form) {
    commit('setLoading', true)
    const data = { ...form }
    if (state.withdrawEventsBody?.px_id) {
      data.event_data = { ...state.withdrawEventsBody }
    }
    try {
      const response = await this.$axios.post('/withdrawals/crypto', data)
      await dispatch('player/profile', true, {
        root: true
      })
      return response.data
    } catch (error) {
    } finally {
      commit('setLoading', false)
    }
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  },
  setWithdrawEventsBody(state, data) {
    state.withdrawEventsBody = data
  },
  setWithdrawalExistingData(state, data) {
    state.withdrawalExistingData = data
  }
}

// Getters
export const getters = {}
